//
//
//
//
//
//
//
//
//
//
//

export default{
	data() {
		return {
		}
	},
	methods: {
		add(){
			uni.redirectTo({
				url:'/pages/strategy/release'
			})
		},
		other() {
			uni.navigateBack({
				delta:1
			})
		}
	},
}
